import Cookies from 'js-cookie'

const TokenKey = 'vue_admin_template_token_20012'

export function getToken() {
  return Cookies.get(TokenKey)
}

export function setToken(token) {
  return Cookies.set(TokenKey, token)
}

export function removeToken() {
  window.localStorage.clear()
  return Cookies.remove(TokenKey)
}

const adminGame = 'game_book_20012'

export function getCookieGame() {
  return Cookies.get(adminGame)
}

export function setCookieGame(game) {
  return Cookies.set(adminGame, game)
}
